import { IconButton, IconButtonProps, Tooltip } from "@mui/material";
import { useCheckPermission } from "commons/hooks/use-check-permission";

export type XIconButtonProps = IconButtonProps & {
  tooltipTitle?: string;
  accessPermission?: "all" | string[];
};
export const XIconButton = ({
  tooltipTitle = "",
  accessPermission,
  ...props
}: XIconButtonProps) => {
  const { allowAccess } = useCheckPermission(accessPermission);
  return (
    <Tooltip title={tooltipTitle}>
      <IconButton
        {...props}
        size="small"
        disabled={props.disabled || !allowAccess}
      >
        {props.children}
      </IconButton>
    </Tooltip>
  );
};
